import './App.css';
import React from 'react';
import { Route, Switch } from 'react-router';
// import { Redirect } from 'react-router';
import home from './paginas/home/home.jsx';
import { Series } from './paginas/series/series.jsx';
import { Notificaciones } from './paginas/notificaciones/noti.jsx';
import { Login } from './paginas/login/login.jsx';
import { Register } from './paginas/Registrarse/register.jsx';
import { InfoProyecto } from "./paginas/infoproyectos/proyectos.jsx";
import { Cap } from './paginas/capitulo/cap.jsx';
import { FamiCartel } from './paginas/familiaCartel/famiCartel.jsx';
import {PerfilFamiCar} from './paginas/perfilFamiCartel/perfilFami.jsx';
import {PerfilUsuario} from './paginas/perfilUsuario/perfilUsu.jsx';
import {EditarProyecto} from './paginas/editarProyecto/editPro.jsx';
import { Administrador } from './paginas/Administrador/admin.jsx';
import {Favoritos} from './paginas/favoritos/favo.jsx';
import { Configuracion } from './paginas/configuracion/config.jsx';


function App() {
  return (
    <div>
      <div className="App">
        <Switch>
          <Route exact path='/' component={home} />
          <Route exact path='/Series' component={Series} />
          <Route exact path='/notificaciones' component={Notificaciones} />
          <Route exact path='/iniciarSesion' component={Login} />
          <Route exact path='/CrearCuenta' component={Register} />
          <Route exact path='/InfoProyectos/:id' component={InfoProyecto} />
          <Route exact path='/Capitulo/:id' component={Cap} />
          <Route exact path='/FamiliaCartel' component={FamiCartel} />
          <Route exact path="/FamiliaCartel/perfil/:id" component={PerfilFamiCar} />
          <Route exact path='/PerfilUsuario' component={PerfilUsuario} />
          <Route exact path='/EditarProyecto/:id' component={EditarProyecto} />
          <Route exact path='/Administrador' component={Administrador} />
          <Route exact path='/Favoritos/:id' component={Favoritos} />
          <Route exact path='/Configuracion' component={Configuracion} />
        </Switch>
      </div>
    </div>

  );
}

export default App;
